/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { useState, useEffect, useContext } from "react";
import { Link, useHistory } from "react-router-dom";
import { withQuery } from "components/common";
import { BreakpointContext } from "components/common/wrappers/withBreakpoint";
import { boostProductTierConfig, boostTiers } from "@tomocredit/common-fe/consts";
import {
  ProductTermToggle,
  BoostPricingTable,
} from "@tomocredit/common-fe/components";
import ConfirmModal from "./BoostUpgradeConfirmModal";
import {
  GET_PRODUCT_STATUS,
} from "../mutations";
import "../BoostLandingStyle.css";

// this decides the order the display of the tiers
const sortingArr = [boostTiers.VIP, boostTiers.PREMIUM, boostTiers.PLUS, boostTiers.BASIC];

/*
  helper function to return available tiers to show to the user
  Monthly --> Yearly (No yearly Plus)
  Yearly --> Yearly (Has Yearly Plus)
*/
const getAvailableTiers = (currentTerm, selectedTerm, currentTierIdx) => {
  if (currentTerm && selectedTerm === currentTerm) {
    return Object.keys(boostProductTierConfig[currentTerm]).filter((_, idx) => {
      return idx > currentTierIdx;
    });
  }
  if (currentTerm === "monthly" && selectedTerm === "yearly") {
    return Object.keys(boostProductTierConfig.yearly).filter((t, idx) => {
      // note: Pricing Page Annual Subs - Remove Basic Tier and Replace with Plus (Test)
      if (currentTierIdx === 0) {
        return t !== boostTiers.PLUS;
      }
      return idx >= currentTierIdx;
    });
  }
  return [];
};

const BoostPricingForUpgrade = ({ data }) => {
  const { isBelow } = useContext(BreakpointContext);
  const belowMd = isBelow("md");
  const currentTier = data?.getUserProductStatus?.productTier;
  const currentTerm = data?.getUserProductStatus?.productTerm || "monthly";
  const history = useHistory();
  const queryParameters = new URLSearchParams(window.location.search);
  const tierRaw = queryParameters.get("tier");
  // const termRaw = queryParameters.get("term");

  // const termFromQueryParam = (currentTier !== "VIP" && ["yearly", "monthly"].includes(termRaw)) ? termRaw : null;
  // const [selectedTerm, setSelectedTerm] = useState(termFromQueryParam || (currentTier === boostTiers.VIP ? "yearly" : currentTerm));

  /* TC-3603 default to yearly only */
  const [selectedTerm, setSelectedTerm] = useState("yearly");

  const [confirmModalOpen, setConfirmModalOpen] = useState(false);

  const tierConfigsForSelectedTerm = boostProductTierConfig[selectedTerm];
  const tiersForSelectedTerms = Object.keys(tierConfigsForSelectedTerm);
  const currentTierIdx = tiersForSelectedTerms.indexOf(currentTier);
  const tiersAvailable = getAvailableTiers(currentTerm, selectedTerm, currentTierIdx);

  // design is that user can only upgrade to higher tier of the same term, or same or above tier of the yearly term
  // if user is on VIP, there will be no monthly upgrade option, therefore hiding the toggle
  const showTermToggle = currentTerm === "monthly" && currentTier !== boostTiers.VIP;

  const tierFromQueryParam = tiersAvailable.includes(tierRaw) ? tierRaw : null;
  const [selectedTier, setSelectedTier] = useState(tierFromQueryParam || boostTiers.VIP);
  tiersAvailable.sort((a, b) => {
    return sortingArr.indexOf(a) - sortingArr.indexOf(b);
  });

  // handle case where tier selected is not available on product term switch
  useEffect(() => {
    if (!tiersAvailable.includes(selectedTier)) {
      setSelectedTier(boostTiers.VIP);
    }
  }, [tiersAvailable, selectedTier]);

  // update tier param on tier selection
  useEffect(() => {
    if (selectedTier) {
      const url = new URL(window.location);
      url.searchParams.set("tier", selectedTier);
      window.history.replaceState(null, "", url.toString());
    }
    if (selectedTerm) {
      const url = new URL(window.location);
      url.searchParams.set("term", selectedTerm);
      window.history.replaceState(null, "", url.toString());
    }
  }, [selectedTier, selectedTerm]);

  // set initial scroll positiion to top
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  // early exit if not available tier to display
  // happens when user is on yearly VIP
  if (!tiersAvailable?.length && currentTerm === "yearly") {
    history.push("/boost");
    return null;
  }

  return (
    <div className="w-full h-full bg-neutral-50" style={{ minWidth: 342 }}>
      <div
        className="w-full dashboard-max-w lg:mx-auto relative h-full pb-20"
      >
        <Link
          to="/boost"
          className="absolute hover:underline hover:font-medium font-medium self-start"
          style={{ left: belowMd ? 0 : 20, top: belowMd ? -36 : 0 }}
        >
          ← Go back
        </Link>
        <div className="mt-10 flex justify-center items-center">
          <h1 className="font-bold text-5xl">
            Pricing
          </h1>
        </div>
        {showTermToggle && (
          <div className="mt-10">
            <ProductTermToggle
              checkoutTerm={selectedTerm}
              setCheckoutTerm={setSelectedTerm}
              belowMd={belowMd}
              theme="white"
            />
          </div>
        )}
        <div className="mt-10 flex justify-center">
          <BoostPricingTable
            tiers={tiersAvailable}
            highlightTier={boostTiers.VIP}
            checkoutTerm={selectedTerm}
            buttonClickCallback={(tier) => {
              setSelectedTier(tier);
              setConfirmModalOpen(true);
            }}
            theme="white"
            showTable={false} // hide table view due to sidebar in dashboard
            isMobileView={isBelow("lg")}
          />
        </div>
        {confirmModalOpen && (
          <ConfirmModal
            confirmModalOpen={confirmModalOpen}
            setConfirmModalOpen={setConfirmModalOpen}
            selectedTerm={selectedTerm}
            selectedTier={selectedTier}
          />
        )}
      </div>
    </div>
  );
};

export default withQuery(GET_PRODUCT_STATUS)(BoostPricingForUpgrade);